module.exports = __webpack_public_path__ + "static/media/Stufful_gaussian2.1b2a9f42.png";